// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__wB71b","bigColWidth":"Table_bigColWidth__7Vi4i","biggerColWidth":"Table_biggerColWidth__1DL-7","row":"Table_row__3p5eP","col":"Table_col__3pbtE"};